webpackJsonp([527],{

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2074:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1120),
  /* template */
  __webpack_require__(2649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/masker-390.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] masker-390.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c904c5e", Component.options)
  } else {
    hotAPI.reload("data-v-3c904c5e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2649:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Masker_COM")]), _vm._v(" "), _c('img', {
    attrs: {
      "width": "100",
      "src": "http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fmasker"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("演示")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "377px",
      "height": "667px",
      "display": "inline-block",
      "border": "1px dashed #ececec",
      "border-radius": "5px",
      "overflow": "hidden"
    }
  }, [_c('iframe', {
    attrs: {
      "src": "https://vux.li/demos/v2/#/component/masker",
      "width": "375",
      "height": "667",
      "border": "0",
      "frameborder": "0"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("demo 代码")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h4', [_vm._v("Github Issue")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "font-size": "12px",
      "color": "#888"
    },
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/masker",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接：https://vux.li/demos/v2/#/component/masker")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"margin: 10px;overflow: hidden;\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-for")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"item in list\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("masker")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"border-radius: 2px;\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"m-img\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"{backgroundImage: 'url(' + item.img + ')'}\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"content\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"m-title\"")]), _vm._v(">")]), _vm._v("\n          "), _c('span', [_vm._v("{{")]), _vm._v("item.title"), _c('span', [_vm._v("}}")]), _vm._v("\n          "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n          "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"m-time\"")]), _vm._v(">")]), _vm._v("2016-03-18"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("masker")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"margin: 10px;overflow: hidden;\"")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("masker")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"border-radius: 2px;\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("color")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"F9C90C\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":opacity")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"0.8\"")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"m-img\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"background-image:url(https://cdn.xiaotaojiang.com/uploads/56/4b3601364b86fdfd234ef11d8712ad/_.jpg)\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"content\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"m-title\"")]), _vm._v(">")]), _vm._v("\n          VUX\n          "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("br")]), _vm._v("/>")]), _vm._v("\n          "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"m-time\"")]), _vm._v(">")]), _vm._v("2016-03-18"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("span")]), _vm._v(">")]), _vm._v("\n        "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n      "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("masker")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _c('span', {
    staticClass: "javascript"
  }, [_vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Masker } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("components")]), _vm._v(": {\n    Masker\n  },\n  data () {\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("list")]), _vm._v(": [{\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'洗颜新潮流！人气洁面皂排行榜'")]), _vm._v(",\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://cdn.xiaotaojiang.com/uploads/82/1572ec37969ee263735262dc017975/_.jpg'")]), _vm._v("\n      }, {\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'美容用品 & 日用品（上）'")]), _vm._v(",\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://cdn.xiaotaojiang.com/uploads/59/b22e0e62363a4a652f28630b3233b9/_.jpg'")]), _vm._v("\n      }, {\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'远离车内毒气，日本车载空气净化器精选'")]), _vm._v(",\n        "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("img")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'https://cdn.xiaotaojiang.com/uploads/56/4b3601364b86fdfd234ef11d8712ad/_.jpg'")]), _vm._v("\n      }]\n    }\n  }\n}\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("script")]), _vm._v(">")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "css"
  }, [_vm._v("\n"), _c('span', {
    staticClass: "hljs-selector-class"
  }, [_vm._v(".m-img")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("padding-bottom")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("33%")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("display")]), _vm._v(": block;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("position")]), _vm._v(": relative;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("max-width")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("100%")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("background-size")]), _vm._v(": cover;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("background-position")]), _vm._v(": center center;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("cursor")]), _vm._v(": pointer;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("border-radius")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("2px")]), _vm._v(";\n}\n\n"), _c('span', {
    staticClass: "hljs-selector-class"
  }, [_vm._v(".m-title")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("color")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("#fff")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("text-align")]), _vm._v(": center;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("text-shadow")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("2px")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("rgba")]), _vm._v("(0, 0, 0, .5);\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("font-weight")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("500")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("font-size")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("16px")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("position")]), _vm._v(": absolute;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("left")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("right")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("width")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("100%")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("text-align")]), _vm._v(": center;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("50%")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("transform")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("translateY")]), _vm._v("(-50%);\n}\n\n"), _c('span', {
    staticClass: "hljs-selector-class"
  }, [_vm._v(".m-time")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("font-size")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("12px")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("padding-top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("4px")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("border-top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("1px")]), _vm._v(" solid "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("#f0f0f0")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("display")]), _vm._v(": inline-block;\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("margin-top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("5px")]), _vm._v(";\n}\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n\n")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c904c5e", module.exports)
  }
}

/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2074);

/***/ })

});


// WEBPACK FOOTER //
// 527.6410f858.js